/* src/app/home/pages/home/home.component.scss */
.dashboardHeader {
  margin-bottom: 0.5rem;
}
.dashboardHeader h2 {
  margin: 0;
  font-weight: 600;
  color: #1e293b;
}
.dashboardHeader p {
  margin: 0.15rem 0 0;
  color: #64748b;
}
.dateRangeRow {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
  background: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 1rem 1.25rem;
}
.dateField {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.dateField label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  margin: 0;
}
.dateField input {
  width: 11rem;
}
.graph-block {
  background: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  min-height: 300px;
  padding: 1rem 1.25rem;
}
/*# sourceMappingURL=home.component.css.map */
